<template>
  <div class="grade-choice-list">
    <div v-if="loading" class="teacher-loading-state"><v-progress-circular size="34" width="3" color="primary" indeterminate /><strong>Loading terms</strong></div>
    <template v-else-if="terms.length">
      <button
        v-for="item in terms"
        :key="item.id || item.name"
        type="button"
        :disabled="item.isLocked"
        :class="{ 'grade-choice-list__item--completed': item.isLocked }"
        @click="termSelected(item)"
      >
        <span class="grade-choice-list__icon">
          <v-icon :color="item.isLocked ? '#7c8880' : '#2f7d4a'">{{ item.isLocked ? "mdi-lock-outline" : "mdi-calendar-check-outline" }}</v-icon>
        </span>
        <span>
          <strong>{{ item.name }}</strong>
          <small :class="termStatusClass(item)">{{ termStatusCopy(item) }}</small>
        </span>
        <span v-if="item.isLocked" class="grade-term-status grade-term-status--completed">Completed</span>
        <span v-else-if="item.completionStatus === 'temporarily_unlocked'" class="grade-term-status grade-term-status--unlocked">Reopened</span>
        <span v-else class="grade-term-status grade-term-status--open">Open</span>
        <v-icon v-if="!item.isLocked" size="19" color="#96a29a">mdi-chevron-right</v-icon>
      </button>
    </template>
    <div v-else class="grade-setup-empty">
      <span><v-icon size="30" color="#8a6525">mdi-calendar-alert-outline</v-icon></span>
      <h3>No terms configured</h3>
      <p>Administration hasn’t created any terms for this academic year.</p>
      <small>Grade entry will become available after a term is created.</small>
    </div>
  </div>
</template>

<script>
import termService from "@/modules/Terms/service.js";
export default {
  name: "term-list",
  props: { YearId: { default: null } },
  data() { return { terms: [], loading: true }; },
  created() { this.getList(); },
  methods: {
    getList() {
      if (!this.YearId) { this.loading = false; return; }
      this.loading = true;
      return termService.getAll({ YearId: this.YearId })
        .then(response => { this.terms = response.data || []; return response; })
        .catch(() => { this.terms = []; })
        .finally(() => { this.loading = false; });
    },
    termStatusCopy(term) {
      if (term.completionStatus === "completed") {
        return term.completionDate ? `Completed ${this.$moment(term.completionDate).format("MMM D, YYYY")}` : "Grade entry is closed";
      }
      if (term.completionStatus === "temporarily_unlocked") {
        return `Reopened until ${this.$moment(term.nextCompletionDate).format("MMM D [at] h:mm A")}`;
      }
      if (term.completionStatus === "legacy_unconfigured") return "No completion deadline configured";
      if (term.nextCompletionDate) return `Grade entry closes ${this.$moment(term.nextCompletionDate).format("MMM D [at] h:mm A")}`;
      return "Continue to student selection";
    },
    termStatusClass(term) {
      if (term.isLocked) return "grade-choice-list__deadline--completed";
      if (term.completionStatus === "temporarily_unlocked") return "grade-choice-list__deadline--unlocked";
      return "";
    },
    termSelected(term) {
      if (!term.isLocked) this.$emit("termSelected", term);
    },
  },
};
</script>

<style scoped>
.grade-choice-list button:disabled { cursor: not-allowed; opacity: 1; }
.grade-choice-list__item--completed { background: #f6f8f6 !important; }
.grade-choice-list__deadline--completed { color: #7c8880 !important; }
.grade-choice-list__deadline--unlocked { color: #3c6e9c !important; }
.grade-term-status { flex: 0 0 auto; padding: 5px 8px; border-radius: 999px; font-size: 10px; font-weight: 750; }
.grade-term-status--completed { color: #66736b; background: #e9eeea; }
.grade-term-status--unlocked { color: #315f80; background: #e8f3fb; }
.grade-term-status--open { color: #24633a; background: #eaf5ed; }
@media (max-width: 359px) {
  .grade-term-status { display: none; }
}
</style>
